import {BorderColor} from '@mui/icons-material'

const hexToRgba = (hex, opacity) => {
    const cleanHex = hex.replace('#', '')
    const r = parseInt(cleanHex.substring(0, 2), 16)
    const g = parseInt(cleanHex.substring(2, 4), 16)
    const b = parseInt(cleanHex.substring(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export default {
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 16,
                    height: 42,
                    minHeight: 42,
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-input': {
                        fontSize: 14,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        borderRadius: 16,
                        backgroundColor: '#f5f5f5',
                    },
                },
                notchedOutline: {
                    borderRadius: 16,
                },
                input: {
                    fontSize: 14,
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    margin: '4px 8px',
                    fontSize: 14,
                    '&.Mui-selected': {
                        backgroundColor: 'transparent !important',
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: 14,
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    fontSize: 14,
                    color: '#00000099',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fbfbfb',
                    border: 'none',
                    fontSize: 14,
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontSize: 16,
                    },
                },
                row: {
                    '&:hover': {
                        backgroundColor: hexToRgba('f2f2f2', 0.45),
                    },
                },
                columnSeparator: {
                    color: '#fbfbfb',
                },
            },
        },
        MuiSkeleton: {
            defaultProps: {animation: 'wave'},
            styleOverrides: {
                root: {
                    backgroundColor: '#0000000d',
                },
                rounded: {
                    borderRadius: 8,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    padding: 16,
                    marginBottom: 16,
                    background: '#ffffff',
                    border: '1px solid #0d5d591f',
                    boxShadow: '0px 0px 7px 0px #0000000d',
                    '&:before': {display: 'none'},
                },
            },
            defaultProps: {square: true},
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    padding: '4px 20px',
                    backgroundColor: '#0D5D590A',
                },
                content: {'&.Mui-expanded': {margin: '12px 0px'}},
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    paddingLeft: 22,
                    paddingRight: 22,
                    paddingTop: 16,
                    paddingBottom: 0,
                },
            },
        },
    },
    palette: {
        DataGrid: {
            headerBg: '#fbfbfb',
        },
        primary: {
            main: '#0D5D59',
            dark: '#073735',
            light: '#B6CECD',
            contrastText: '#FFFFFF',
            hover: hexToRgba('0D5D59', 0.04),
            selected: hexToRgba('0D5D59', 0.08),
            focus: hexToRgba('0D5D59', 0.12),
            focusVisible: hexToRgba('0D5D59', 0.3),
            outlinedBorder: hexToRgba('0D5D59', 0.5),
        },
        secondary: {
            main: '#99BD90',
            dark: '#556950',
            light: '#D4E8D0',
            contrastText: '#FFFFFF',
            hover: hexToRgba('99BD90', 0.08),
            selected: hexToRgba('99BD90', 0.12),
            focus: hexToRgba('99BD90', 0.15),
            focusVisible: hexToRgba('99BD90', 0.3),
            outlinedBorder: hexToRgba('99BD90', 0.5),
        },
        error: {
            main: '#D32F2F',
            dark: '#C62828',
            light: '#EF5350',
            contrastText: '#FFFFFF',
            hover: hexToRgba('D32F2F', 0.04),
            selected: hexToRgba('D32F2F', 0.08),
            focusVisible: hexToRgba('D32F2F', 0.3),
            outlinedBorder: hexToRgba('D32F2F', 0.5),
        },
        warning: {
            main: '#ED6C02',
            dark: '#E65100',
            light: '#FF9800',
            contrastText: '#FFFFFF',
            hover: hexToRgba('ED6C02', 0.04),
            selected: hexToRgba('ED6C02', 0.08),
            focusVisible: hexToRgba('ED6C02', 0.3),
            outlinedBorder: hexToRgba('ED6C02', 0.5),
        },
        info: {
            main: '#0288D1',
            dark: '#01579B',
            light: '#03A9F4',
            contrastText: '#FFFFFF',
            hover: hexToRgba('0288D1', 0.04),
            selected: hexToRgba('0288D1', 0.08),
            focusVisible: hexToRgba('0288D1', 0.3),
            outlinedBorder: hexToRgba('0288D1', 0.5),
        },
        success: {
            main: '#2E7D32',
            dark: '#1B5E20',
            light: '#4CAF50',
            contrastText: '#FFFFFF',
            hover: hexToRgba('2E7D32', 0.04),
            selected: hexToRgba('2E7D32', 0.08),
            focusVisible: hexToRgba('2E7D32', 0.3),
            outlinedBorder: hexToRgba('2E7D32', 0.5),
        },
        action: {
            active: hexToRgba('000000', 0.56),
            hover: hexToRgba('000000', 0.04),
            selected: hexToRgba('000000', 0.08),
            disabledBackground: hexToRgba('000000', 0.12),
            focus: hexToRgba('000000', 0.12),
            disabled: hexToRgba('000000', 0.38),
        },
        text: {
            primary: hexToRgba('1D1D1B', 0.87),
        },
        grey: {
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
            A100: '#D5D5D5',
            A200: '#AAAAAA',
            A400: '#616161',
            A700: '#303030',
        },
        background: {
            default: '#F5F5F5',
            paper: '#FFFFFF',
        },
    },
    typography: {
        h1: {fontWeight: 600, fontSize: 72, lineHeight: '116.7%', letterSpacing: '-1.5px'},
        h2: {fontWeight: 600, fontSize: 60, lineHeight: '120%', letterSpacing: '-0.5px'},
        h3: {fontWeight: 600, fontSize: 48, lineHeight: '116.7%', letterSpacing: '0px'},
        h4: {fontWeight: 600, fontSize: 34, lineHeight: '123.5%', letterSpacing: '0.25px'},
        h5: {fontWeight: 600, fontSize: 24, lineHeight: '133.4%', letterSpacing: '0px'},
        h6: {fontWeight: 600, fontSize: 20, lineHeight: '100%', letterSpacing: '0.15px'},
        h7: {fontWeight: 600, fontSize: 18, lineHeight: 'normal', letterSpacing: '0px'},
        h8: {fontWeight: 600, fontSize: 16, lineHeight: 'normal', letterSpacing: '0px'},
        h9: {fontWeight: 600, fontSize: 14, lineHeight: 'normal', letterSpacing: '0px'},
        h10: {fontWeight: 600, fontSize: 12, lineHeight: 'normal', letterSpacing: '0px'},
        body1: {fontWeight: 400, fontSize: 16, lineHeight: '150%', letterSpacing: '0.15px'},
        body2: {fontWeight: 400, fontSize: 14, lineHeight: '125%', letterSpacing: '0px'},
        body3: {fontWeight: 400, fontSize: 12, lineHeight: 'normal', letterSpacing: '0px'},
        subtitle1: {fontWeight: 400, fontSize: 16, lineHeight: '175%', letterSpacing: '0.15px'},
        subtitle2: {fontWeight: 400, fontSize: 14, lineHeight: '157%', letterSpacing: '0.1px'},
        overline: {fontWeight: 400, fontSize: 12, lineHeight: '266%', letterSpacing: '1px'},
        caption: {fontWeight: 400, fontSize: 12, lineHeight: '166%', letterSpacing: '0.4px'},
        button: {fontSize: 14, fontWeight: 500, lineHeight: '26px', letterSpacing: '0.46px'},
        alertTitle: {fontWeight: 500, fontSize: 16, lineHeight: '150%', letterSpacing: '0.15px'},
        alertDescription: {fontWeight: 500, fontSize: 14, lineHeight: '143%', letterSpacing: '0.15px'},
        avatarInitials: {fontWeight: 400, fontSize: 30, lineHeight: '20px', letterSpacing: '0.14px'},
        badgeLabel: {fontWeight: 500, fontSize: 12, lineHeight: '20px', letterSpacing: '0.14px'},
        buttonLarge: {fontWeight: 500, fontSize: 14, lineHeight: '26px', letterSpacing: '0.46px'},
        buttonMedium: {fontWeight: 500, fontSize: 14, lineHeight: '24px', letterSpacing: '0.4px'},
        buttonSmall: {fontWeight: 500, fontSize: 13, lineHeight: '22px', letterSpacing: '0.46px'},
        inputLabel: {fontWeight: 500, fontSize: 12, lineHeight: '12px', letterSpacing: '0.15px'},
        helperText: {fontWeight: 400, fontSize: 12, lineHeight: '166%', letterSpacing: '0.4px'},
        inputText: {fontWeight: 400, fontSize: 14, lineHeight: '24px', letterSpacing: '0.15px'},
        chipLabel: {fontWeight: 400, fontSize: 13, lineHeight: '18px', letterSpacing: '0.16px'},
        tooltipLabel: {fontWeight: 500, fontSize: 10, lineHeight: '14px', letterSpacing: '0px'},
        tableHeader: {fontWeight: 500, fontSize: 14, lineHeight: '24px', letterSpacing: '0.17px'},
        menuItem: {fontWeight: 400, fontSize: 16, lineHeight: '150%', letterSpacing: '0.15px'},
        menuItemDense: {fontWeight: 400, fontSize: 14, lineHeight: '24px', letterSpacing: '0.17px'},
        listSubheader: {fontWeight: 500, fontSize: 14, lineHeight: '48px', letterSpacing: '0.1px'},
        bottomNavigation: {fontWeight: 400, fontSize: 14, lineHeight: '166%', letterSpacing: '0.4px'},
        datePickerCurrentMonth: {fontWeight: 500, fontSize: 16, lineHeight: '150%', letterSpacing: '0.15px'},
    },
}
